'use strict';

console.log('2.1 - main.js ');

//import PhotoSwipe from 'photoswipe';
//import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
//import AWSCognito from 'aws-sdk';
//import AWSLambda from 'aws-sdk';
import Marked from 'marked';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import Vuex from 'vuex';
import { sync } from 'vuex-router-sync';
import VModal from 'vue-js-modal';
import VueSimpleSVG from 'vue-simple-svg';
//import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
//import Swiper from 'swiper/dist/js/swiper.js';
//import Swiper from 'swiper';
//import 'swiper/dist/css/swiper.css';

import App from '../../../components/app.vue';
import Intro from '../../../components/intro.vue';
import Home from '../../../components/home.vue';
import About from '../../../components/about.vue';
import GenericPage from '../../../components/generic-page.vue';
import Gallery from '../../../components/gallery.vue';
import Projects from '../../../components/projects.vue';
import SocialIcons from '../../../components/social-icons.vue';
import NewsIndex from '../../../components/news-index.vue';
import NewsDetail from '../../../components/news-detail.vue';
import Partners from '../../../components/partners.vue';
import Contact from '../../../components/contact.vue';

/**
 * Disable Vue dev tools when compiling to production
*/
if (process.env.NODE_ENV == 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
  Vue.config.productionTip = false
}

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a
});
Vue.use(Vuex)
Vue.use(VModal, { componentName: "overlay", dynamic: true } )
Vue.use(VueSimpleSVG)
//Vue.use(VueTruncate)

/* 
* content truncate filter
*/
var truncateFilter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', truncateFilter);

/**
 * Register Global Components
 */
Vue.component('social-icons', SocialIcons);

/**
 * Register Routes
 */
const routes = [
  { 
    path: '/', 
    component: Intro,
    props: { pageMarkdownFileName: 'index.md'},
    name: 'intro'
  },
  { 
    path: '/home/', 
    component: Home,
    props: { pageMarkdownFileName: 'home.md'},
    name: 'home'
  },
  { 
    path: '/about/', 
    component: About,
    props: { pageMarkdownFileName: 'about.md'},
    name: 'about'
  },
  { 
    path: '/projects/', 
    component: Projects,
    props: { pageMarkdownFileName: 'projects.md'},
    name: 'projects'
  },
  { 
    path: '/gallery/', 
    component: Gallery,
    props: { pageMarkdownFileName: 'gallery.md'},
    name: 'gallery'
  },
  { 
    path: '/news/', 
    component: NewsIndex,
    props: { pageMarkdownFileName: 'news.md'},
    name: 'news-index'
  },
  { 
    path: '/partners/', 
    component: Partners,
    props: { pageMarkdownFileName: 'partners.md'},
    name: 'partners'
  },
  { 
    path: '/news/:id', 
    component: NewsDetail,
    props: { pageName: 'news.md' },
    name: 'news-detail'
  },
  { 
    path: '/contact/', 
    component: Contact,
    props: { pageMarkdownFileName: 'contact.md'},
    name: 'contact'
  },
  { 
    path: '/privacy-policy/', 
    component: GenericPage,
    props: { pageMarkdownFileName: 'privacy-policy.md'},
    name: 'privacy-policy'
  },
  { 
    path: '/terms-of-use/', 
    component: GenericPage,
    props: { pageMarkdownFileName: 'terms-of-use.md'},
    name: 'terms-of-use'
  },
  { 
    path: '/page-not-found/', 
    component: GenericPage,
    props: { pageMarkdownFileName: '404.md'},
    name: 'page-not-found'
  },
  { 
    path: '/wait-list/', 
    component: GenericPage,
    props: { pageMarkdownFileName: 'custom-error.md'},
    name: 'wait-list'
  }
  //{ 
    //path: '/tickets/', 
    //component: Tickets,
    //props: { pageMarkdownFileName: 'tickets.md', isTicketsPage: true },
    //name: 'tickets'
  //}
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return { selector: to.hash }
    }
    else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => { 
  if (!to.matched.length) {
    next('/page-not-found/');
  } else {
    next();
  }
});

//var bodyElement = document.getElementById('body-element');

router.afterEach((to, from, next) => {
  if (to.hash) {
    //console.log('afterEach if', to, to.hash);
  }
  else {
    //console.log('afterEach else', to, to.hash);
    //setTimeout(() => {
      //bodyElement.scrollTop = 0;
      //console.log('route scrollBehavior', bodyElement);
    //}, 100);
  }
});

Vue.prototype.$site_name = 'Mobocratic Republic';
Vue.prototype.$http = axios;


$(window).on('load', function() { 
  //$('body').addClass("relative");
  //$('#bg-home').removeClass("bg-home-black");
});

/**
 * Find unintended horizontal body overflow
 */
var docWidth = document.documentElement.offsetWidth;

[].forEach.call(
  document.querySelectorAll('*'),
  function(el) {
    if (el.offsetWidth > docWidth) {
      console.log(el);
    }
  }
);

Vue.mixin({
  mounted() {
   // console.log('main.js global mixin: mounted() DOC READY', window.location.pathname);

    /****************************
    Initialize Swiper on Info page
    ****************************/    
    if (window.location.pathname == '/info/') {   
      var mySwiper = new Swiper ('.swiper-container', {
        speed: 400,
        lazyLoading: true,
        slidesPerView: '3',
        spaceBetween: 30,
        centeredSlides: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          }
        }
      });
      // Center 2nd slide
      mySwiper.slideNext();
    }

    /****************************
    Initialize Swiper on Experiences page
    ****************************/    
    if (window.location.pathname == '/experiences/') {
        var mySwiper = new Swiper ('.swiper-container', {
          speed: 400,
          lazyLoading: true,
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
      })
    }

    this.$nextTick(() => {
      /****************************
      DOC READY
      ****************************/
      $(function() {
        /****************************
        Lazy Load images
        ****************************/
        if ($('.lazy-load')) {
          $('.lazy-load').each(function(index) {
            var $this = $(this),
                dataSource = $this.data('src');
            var image = document.createElement('img');

            image.onload = function() {
              $this
                .attr('src', dataSource)
                .addClass('loaded');
            };
            image.src = dataSource;
          });
        }

        /****************************
        Links with class disable prevent linking
        ****************************/
        
        $('.disabled').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
        });

      });
      /****************************
      End DOC READY
      ****************************/
    });
  }
})

  /****************************
  Setup Global Event bus for methods shared between components
  ****************************/
  export const bus = new Vue();

  /****************************
  GET site pages and posts in json via axios
  ****************************/
 var n = v;

    //axios.get('https://jsonplaceholder.typicode.com/users')
    axios.get('/data/data.json?v=' + n)
      .then(function (response) {
        var vm = this;
        var error = null;
        //console.log('main.js 1 - response: ', response);
        var siteData = response.data;
        //console.log('main.js 3 - data: ', response);
        const store = new Vuex.Store({
          state: {
            data: siteData,
            message: 'Hello World',
          },
          mutations: {
            //
          },
          actions: {
            //
          },
          getters: {
            message(state) {
              return state.message.toUpperCase();
            },
            data(state) {
              return state.data;
            },
            filterPagesByName: state => name => state.data.filter(data => data.name === name),
            filterPostsByUrl: state => url => state.data.filter(data => data.url === url),     
            filterDataByCollection: state => collection => state.data.filter(data => data.collection === collection),  
            filterDataByPermalink: state => permalink => state.data.filter(data => data.permalink === permalink),     
          }
        });
        const unsync = sync(store, router) // done. Returns an unsync callback fn
        var app = new Vue({
          beforeCreate: function () {
            //console.log('$site_name - ', this.$site_name);
          },
          el: '#app', 
          router,
          store,
          components: {
            'app': App
          },
          //template: '<app :appIsLoaded="appLoaded"></app>',
          render(h) {
            return h(App, {
              props: {
                appIsLoaded: this.appIsMounted
              }
            })
          },
          data: {
            appIsMounted: false
          },
          methods: {
            //
          },
          computed: {
            siteData() {
              return store.getters.data;
            }
          },
          mounted() {
            this.appIsMounted = true;
            this.$nextTick(() => {
              $(function() {
                //$(window).on('load', function() { 
                  //console.log('mounted()');
                //});
                //console.log('main.js - RESPONSE: mounted() - DOCUMENT READY');
              })
            });
          }
        });
      })
      .catch(function (error) {
        console.log('catch - error', error);
        var app = new Vue({
          beforeCreate: function () {
            //console.log('$site_name - ', this.$site_name);
          },
          el: '#app', 
          router,
          components: {
            'app': App
          },
          template: '<app :appIsLoaded="appLoaded"></app>',
          //render: h => h(App),
          data: {
            appLoaded: false
            //users: [],
          },
          mounted() {
            this.$nextTick(() => {
              $(function() {
                //console.log('main.js - CATCH: mounted() - DOCUMENT READY', window);
              })
            });
          }
        });
      });

/****************************
SEAF 
****************************/
(function(window) {
  //console.log('SEAF');
})(window);
/****************************
End SEAF 
****************************/

